// extracted by mini-css-extract-plugin
module.exports = {"text":"Item_text__iZ9-S","title":"Item_title__3hOBC","content":"Item_content__2LBte","container":"Item_container__30CI2"};